module.exports = __webpack_public_path__ + "img/droplet.b1eee82c.svg";